import { getViewportForWidth } from 'app/utils/viewports';

export const Types = {
  GLOBAL_VIEWPORT_CHANGED: 'GLOBAL_VIEWPORT_CHANGED',
};

export const initialState = {
  viewport: getViewportForWidth(window.innerWidth),
};

export const Actions = {
  viewportChanged: viewport => ({
    viewport,
    type: Types.GLOBAL_VIEWPORT_CHANGED,
  }),
};



// WEBPACK FOOTER //
// ./src/redux/globals/actions.js